import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';

interface IProps {
    customerId: string;
    authorizedUserId: string;
    password: string;
    token: string;
}

export const useSetPassword = () => useMutation('', async ({
  customerId, authorizedUserId, password, token,
}: IProps) => {
  const { data } = await httpService.post(`/api/v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/password`, {
    setPasswordData: {
      password,
    },
    token,
  });
  return data;
});
